/* prettier-ignore */

export const content = {
  'designer.tokens.color.hiddenDescription': 'Search for color tokens using name or hex value, or set a color.',
  'designer.tokens.color.add': 'Add color token',
  'designer.tokens.color.roles.with-permission.create': 'create color tokens',
  'designer.tokens.color.roles.no-permission.create': "Color tokens can't be created",
  'designer.tokens.color.roles.with-permission.edit': 'edit color tokens',
  'designer.tokens.color.roles.no-permission.edit': "Color tokens can't be edited",
  'designer.tokens.color.roles.with-permission.delete': 'delete color tokens',
  'designer.tokens.color.roles.no-permission.delete': "Color tokens can't be deleted",
  'designer.tokens.manager.list.empty-state.header': "No variables yet",
  'designer.tokens.manager.list.empty-state.body': "Create variables to reuse design values and maintain consistency",
  'designer.tokens.manager.list.search-empty-state.header': "No variables matching {{term}}",
  'designer.tokens.manager.list.search-empty-state.body': "Use a different search term or reset the search to view all variables",
  'designer.tokens.manager.list.search.placeholder': "Search variables...",
  'designer.tokens.manager.roles.no-permission.create': "create variables",
  'designer.tokens.manager.branch.no-permission.create': "Variables can't be created",
  'designer.tokens.manager.roles.no-permission.modify': "edit variables",
  'designer.tokens.manager.branch.no-permission.modify': "Variables can't be edited",
  'designer.tokens.manager.roles.no-permission.delete': "delete variables",
  'designer.tokens.manager.branch.no-permission.delete': "Variables can't be deleted",
  'designer.tokens.manager.roles.no-permission.restore': "restore variables",
  'designer.tokens.manager.branch.no-permission.restore': "Variables can't be restored",
  'designer.tokens.panel.open': "Open variables panel",
  'designer.tokens.ai.chat.entrypoint.base.description': "You can now get AI-powered help right here as you build in Webflow. Ask a question or click on an option below.",
  'designer.tokens.ai.chat.entrypoint.stylePanelStyle.tooltip': "Learn how to reuse styles with AI Help.",
  'designer.tokens.ai.chat.entrypoint.stylePanelStyle.description': `Styles are saved as classes within blue tags, and can be reused by applying the same class:

1. Select the element you want to apply a saved style (or class) to.
2. In the Style selector section of the Style panel, search for the class you want to apply to this element
3. Once you select the class, it gets applied to the selected element.

Note: Each class is saved with a unique name. You can rename classes to make them easier to find.`,
  'designer.tokens.ai.chat.entrypoint.responsiveLayout.tooltip': "Learn how to make your site responsive with AI Help.",
  'designer.tokens.ai.chat.entrypoint.responsiveLayout.description': `You can make your site responsive by setting specific styles for different screen sizes. Webflow makes it simple with 7 built-in breakpoints such as desktop, tablet and mobile.

For example, if you change certain styles on the tablet breakpoint, they’ll be carried down to the mobile breakpoints, but not up to the desktop.

Note: Styles saved on any breakpoint smaller than desktop cascade down, but not up.`,
  'designer.tokens.ai.chat.entrypoint.stylePanelLayout.tooltip': "Learn how to align elements with AI Help.",
  'designer.tokens.ai.chat.entrypoint.stylePanelLayout.description': `To align elements, select the parent element of the child element(s) you’d like to align. Next:

Open the Style panel > Layout > Display section.
Select “Flex” as the display setting for this parent element.
Complete the alignment by adjusting further settings such as Direction, Align and Justify.`,
  'designer.tokens.ai.chat.entrypoint.addPanelStructure.tooltip': "Learn how to create a layout with AI Help.",
  'designer.tokens.ai.chat.entrypoint.addPanelStructure.description': `Start creating a layout by adding these 3 Structure elements:

1. Section: To create the first part of your page, drag a Section to the canvas.
2. Container: To center contents, add a Container inside the Section.
3. Quick Stack: Now start building your layout by adding a Quick Stack inside the Container.

Next, customize the Quick Stack and add all other elements inside it.`,

} as const;
